<template>
  <div @click="setShowDetail" style="cursor: pointer;" class="detail-btn upper" v-if="$store.getters.metaMaskObj.isConnect">
    <el-button type="text" class="upper" >
      {{label}}
    </el-button>
    <br />
    <i :class="['el-icon-d-arrow-right', {'is-expanded': isExpanded}]" />
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: () => "detail"
    },
    isExpanded: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
    };
  },
  computed: {},
  methods: {
    setShowDetail() {
      this.$emit("clickHandle");
      if (!this.isExpanded) {
        this.toBottom();
      }
    },
    toBottom() {
      this.$nextTick(() => {
        window.scrollTo({
          'top': document.documentElement.clientHeight,
          'behavior': 'smooth'
        })
      })
    },
  },
};
</script>

<style scoped lang="scss">

.upper {
  font-family: DMSans-Regular;
}

.el-icon-d-arrow-right {
  transform: rotate(-90deg);
  transition: transform 0.3s ease;
  
  &.is-expanded {
    transform: rotate(90deg);
  }
}
</style>
